/**
 * Get layout-specific attributes for `Paddle.Checkout.open()`.
 *
 * @see https://developer.paddle.com/guides/how-tos/checkout/inline-checkout
 */
function getPaddleCheckoutAttributes() {
  return {
    // Layout
    method: "inline",
    displayModeTheme: "light",
    locale: document.querySelector("html").getAttribute("lang").substr(0, 2),
    // Disable not required features
    allowQuantity: false,
    disableLogout: true,
    // Iframe configuration
    frameInitialHeight: 600,
    frameStyle: "width:100%; background-color: transparent; border: none;"
  };
}
export { getPaddleCheckoutAttributes };